import { CHANNEL_ID, MEMBER_ID, StringTMap } from '@@types/common';

import { mainDetailUiState } from '~/stores/DetailUiState';
import { uiState } from '~/stores/UiState';
import { isEmpty } from 'lodash';
import { action, computed, observable, set } from 'mobx';
import { curry } from 'ramda';

export type ReadSeqInfo = {
  memberId: MEMBER_ID;
  readSeq: number;
};

type MemberReadSeqBody = { channelId: CHANNEL_ID; memberId: MEMBER_ID; readSeq: number };

class ChannelReadSeqStore {
  @observable
  map: StringTMap<StringTMap<ReadSeqInfo>> = {};

  @action
  public setChannelReadSeq = curry((channelId: CHANNEL_ID, readSeq: StringTMap<ReadSeqInfo>) => {
    this.map = uiState.pickAndSetLruChannelIds(channelId, readSeq)(this.map);
  });

  @computed
  get readSeq() {
    return this.map[mainDetailUiState.contentsChannelId];
  }

  getByChannelId = (channelId: CHANNEL_ID): StringTMap<ReadSeqInfo> => {
    return this.map[channelId];
  };

  setCurrentMemberReadSeq = (params: MemberReadSeqBody) => {
    if (mainDetailUiState.contentsChannelId !== params.channelId) return;
    this.setMemberReadSeq(params);
  };

  @action
  private setMemberReadSeq = ({ channelId, memberId, readSeq }: MemberReadSeqBody) => {
    if (isEmpty(this.map[channelId])) {
      this.setChannelReadSeq(channelId, {});
    }
    set(this.map[channelId], memberId, { memberId, readSeq });
  };
}

export default ChannelReadSeqStore;

export const channelReadSeqStore = new ChannelReadSeqStore();
